import type { OverLayEvents } from '@/services/overlay/types';
import mitt, { type EventType } from 'mitt';

export type AppEvents = Record<EventType, any> & OverLayEvents;

const eventService = mitt<AppEvents>();

export default eventService;
